import { state } from '@angular/animations';
import { NavigatorService } from './../shared/navigator/navigator.service';
import { PrecalculatedConfiguration } from './../shared/precalculated-configuration.interface';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebcallsService } from '../webcalls.service';
import { DataproviderService } from '../dataprovider.service';
import { timer } from 'rxjs';
import { CookieService } from '../services/cookie.service';
import {FormControl, Validators} from '@angular/forms';

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss", "./home-page.component.responsive.scss"]
})
export class HomePageComponent implements OnInit, AfterViewInit {
  /* private vars */

  videoURL = "../assets/video/home2.mp4";
  hostName: string = window.location.hostname;
  timeLeft: number = 44; //timer countdown
  interval;
  subscribeTimer: any;
  //skipBtnVisible: boolean = false;
  soundToogler: boolean = false;
  sharewithInstaller: boolean = false;

  @ViewChild("homeVideo") video: ElementRef;

  constructor(
    private router: Router,
    private ws: WebcallsService,
    private dp: DataproviderService,
    private ns: NavigatorService,
    private _cookie: CookieService
  ) {}

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.stopTimer();
      }
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.interval);
  }

  ngOnInit() {
    //this.selectVideo();
    this.ws.setBaseUrl(this.hostName);
    this.wsCall();
  }

  selectVideo(){
    /* deprecated
    let w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x,
        y;

    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

    if (x <= 520) {
      this.videoURL = "../assets/video/intro.mp4";
    } else {
      this.videoURL = "../assets/video/intro_hd.mp4";
    }*/
  }

  ngAfterViewInit(): void {
    /* deprecated
    if (this.video) {
      this.video.nativeElement.onended = (e: Event) => {
        if (this.skipBtnVisible && this._cookie.getCookie(this._cookie.COOKIE_CONSENT) === '1') {
          //if (this.interval) this.stopTimer();
          this.goToNextPage();
        } else {
          this.video.nativeElement.currentTime = 0;
        }
      };
    } else {
      //this.startTimer();
    }*/
  }

  wsCall() {
    let host = this.hostName != "localhost" ? this.hostName : "http://casab2c.demorooms.com";
    this.ws.getLocalization(host).subscribe(data => {
      // save in dataprovider all the localization properties
      this.dp.setLocalization(data);
      this.dp.getFinishings(data["ID"]);
      this.dp.getCoverData(data["ID"]);
      if (data["ShareWithInstaller"]){
        this.sharewithInstaller = true;
      }
    });
  }


  btnOpenQuotation() {
    this.stopTimer();
    this.dp.resetDataProvider();
    this.ns.navigateRoute("/open");
  }

  btnNewQuotation() {
    this.stopTimer();
    this.dp.resetDataProvider();
    this.ns.navigateRoute("/wiz/whattodo");
  }

  goToNextPage() {
    this.ns.navigateRoute("/wiz/whattodo");
  }

  onToggleAudio() {
    if (this.video) {
      this.soundToogler = !this.soundToogler;
      this.video.nativeElement.muted = !this.video.nativeElement.muted;
    }
  }
  goToSharePage() {
    this.ns.navigateRoute("/share");
  }
}
